<template>
  <div>
    <div id="oauth-success" class="flex center" style="flex-direction:column">
      <img width="450" src="@/assets/img/happy.png" />
      <h3>Integração realizada com sucesso!</h3>
      <p>
        Selecione no painel as contas do Google Ads que você quer sincronizar.
      </p>

      <div class="buttons small">
        <div @click="closeWindow()" class="button secondary">
          Fechar
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import logo4 from "@/assets/img/integration/logo-4.png";

export default {
  name: "facebook-ads",
  data() {
    return {
      // logo: logo4
    };
  },
  methods: {
    closeWindow() {
      window.open("", "_parent", "");
      window.close();
    },
  },
};
</script>

<style lang="scss" scoped>
#oauth-success {
  padding-top: 30px;
  align-items: center;
  img {
    margin-bottom: 30px;
  }
  .buttons {
    margin-top: 30px;
  }
}
</style>
